const style = { height: "auto", width: "24px" };
const smStyle = { height: "auto", width: "16px" };
export const AddIcon = () => {
  return (
    <svg
      id="add"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      viewBox="0 0 24 24">
      <path id="Path_10" data-name="Path 10" d="M0,0H24V24H0Z" fill="none" />
      <path
        id="Path_11"
        data-name="Path 11"
        d="M19,13H13v6H11V13H5V11h6V5h2v6h6Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const AlertCircleIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      viewBox="0 0 24 24"
      fill="none"
      stroke="#ffffff"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-alert-circle">
      <circle cx="12" cy="12" r="10"></circle>
      <line x1="12" y1="8" x2="12" y2="12"></line>
      <line x1="12" y1="16" x2="12.01" y2="16"></line>
    </svg>
  );
};
export const AlertTriangleIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      viewBox="0 0 24 24"
      fill="none"
      stroke="#fff"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-alert-triangle">
      <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
      <line x1="12" y1="9" x2="12" y2="13"></line>
      <line x1="12" y1="17" x2="12.01" y2="17"></line>
    </svg>
  );
};
export const BubbleChartIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      style={style}
      fill="#FFFFFF">
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M19.23 15.26l-2.54-.29c-.61-.07-1.21.14-1.64.57l-1.84 1.84c-2.83-1.44-5.15-3.75-6.59-6.59l1.85-1.85c.43-.43.64-1.03.57-1.64l-.29-2.52c-.12-1.01-.97-1.77-1.99-1.77H5.03c-1.13 0-2.07.94-2 2.07.53 8.54 7.36 15.36 15.89 15.89 1.13.07 2.07-.87 2.07-2v-1.73c.01-1.01-.75-1.86-1.76-1.98z" />
    </svg>
  );
};
export const CheckIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      viewBox="0 0 24 24"
      fill="none"
      stroke="#fff"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-check">
      <polyline points="20 6 9 17 4 12"></polyline>
    </svg>
  );
};

export const MoonIcon = () => {
  return (
    <svg
      id="moon"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      viewBox="0 0 24 24">
      <rect
        id="Rectangle_1"
        data-name="Rectangle 1"
        width="24"
        height="auto"
        fill="none"
      />
      <path
        id="Path_1"
        data-name="Path 1"
        d="M12,3a9,9,0,1,0,9,9,10.122,10.122,0,0,0-.1-1.36A5.4,5.4,0,1,1,13.36,3.1,10.122,10.122,0,0,0,12,3Z"
        fill="#45576f"
      />
    </svg>
  );
};
export const HeartIcon = ({ fill = false }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ height: "auto", width: "1rem" }}
      viewBox="0 0 17 15.855">
      <path
        id="Path_5"
        data-name="Path 5"
        d="M10,17.68,8.84,16.624C4.72,12.888,2,10.424,2,7.4A4.357,4.357,0,0,1,6.4,3,4.791,4.791,0,0,1,10,4.672,4.791,4.791,0,0,1,13.6,3,4.357,4.357,0,0,1,18,7.4c0,3.024-2.72,5.488-6.84,9.232Z"
        transform="translate(-1.5 -2.5)"
        fill={fill ? "#ff7790" : "none"}
        stroke="#ff7790"
        strokeWidth="1"
      />
    </svg>
  );
};
export const CloseIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      viewBox="0 0 24 24"
      fill="none"
      stroke="#fff"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-x">
      <line x1="18" y1="6" x2="6" y2="18"></line>
      <line x1="6" y1="6" x2="18" y2="18"></line>
    </svg>
  );
};
export const SubtractIcon = () => {
  return (
    <svg
      id="remove"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      viewBox="0 0 24 24">
      <path id="Path_12" data-name="Path 12" d="M0,0H24V24H0Z" fill="none" />
      <path
        id="Path_13"
        data-name="Path 13"
        d="M19,13H5V11H19Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const StarIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={smStyle}
      viewBox="0 0 18 17.216">
      <path
        id="star"
        d="M10,2l2.472,5.008L18,7.816l-4,3.9.944,5.5L10,14.616l-4.944,2.6L6,11.712l-4-3.9,5.528-.808Z"
        transform="translate(-1 -1)"
        fill="#fff"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  );
};
export const SunIcon = () => {
  return (
    <svg
      id="wb_sunny_black_24dp"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      viewBox="0 0 24 24">
      <path id="Path_2" data-name="Path 2" d="M0,0H24V24H0Z" fill="none" />
      <path
        id="Path_3"
        data-name="Path 3"
        d="M6.76,4.84,4.96,3.05,3.55,4.46,5.34,6.25ZM4,10.5H1v2H4ZM13,.55H11V3.5h2V.55Zm7.45,3.91L19.04,3.05,17.25,4.84l1.41,1.41Zm-3.21,13.7,1.79,1.8,1.41-1.41-1.8-1.79-1.4,1.4ZM20,10.5v2h3v-2Zm-8-5a6,6,0,1,0,6,6A6,6,0,0,0,12,5.5ZM11,22.45h2V19.5H11ZM3.55,18.54l1.41,1.41,1.79-1.8L5.34,16.74Z"
        fill="#f7fafc"
      />
    </svg>
  );
};
export const HomeIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      style={style}
      fill="currentColor">
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
    </svg>
  );
};
export const CartIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      style={style}
      fill="currentColor">
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z" />
    </svg>
  );
};

export const WishlistIcon = () => {
  return (
    <svg
      id="favorite_black_24dp"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      viewBox="0 0 24 24">
      <path id="Path_8" data-name="Path 8" d="M0,0H24V24H0Z" fill="none" />
      <path
        id="Path_9"
        data-name="Path 9"
        d="M12,21.35l-1.45-1.32C5.4,15.36,2,12.28,2,8.5A5.447,5.447,0,0,1,7.5,3,5.988,5.988,0,0,1,12,5.09,5.988,5.988,0,0,1,16.5,3,5.447,5.447,0,0,1,22,8.5c0,3.78-3.4,6.86-8.55,11.54Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const BagIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      style={style}
      fill="currentColor">
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M19 6h-2c0-2.76-2.24-5-5-5S7 3.24 7 6H5c-1.1 0-1.99.9-1.99 2L3 20c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-7-3c1.66 0 3 1.34 3 3H9c0-1.66 1.34-3 3-3zm0 10c-2.76 0-5-2.24-5-5h2c0 1.66 1.34 3 3 3s3-1.34 3-3h2c0 2.76-2.24 5-5 5z" />
    </svg>
  );
};
export const UserIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      style={style}
      fill="currentColor">
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
    </svg>
  );
};
export const Logo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ height: "auto", width: "10rem" }}
      viewBox="0 0 313.355 96.805">
      <g
        id="greenify_logo_horizontal"
        data-name="greenify logo horizontal"
        transform="translate(-42.224 -64.405)">
        <g id="Group_6" data-name="Group 6">
          <path
            id="Path_30"
            data-name="Path 30"
            d="M56.71,126.54a2.349,2.349,0,0,0-3.03,3.59l19.64,16.59v9.69a28.516,28.516,0,0,1-19.72-9.42c-11.36-13.24-6.09-32.26.34-45.88,3.29-6.97,8.92-15.01,13.95-21.41a2.351,2.351,0,0,0-3.7-2.9c-5.18,6.59-11.03,14.94-14.5,22.3-10.07,21.34-9.95,38.96.34,50.95,6,6.99,15.25,11.06,25.37,11.16h.02a2.677,2.677,0,0,0,2.59-2.53V145.64a2.324,2.324,0,0,0-.83-1.79Z"
            fill="#4d822b"
          />
          <path
            id="Path_31"
            data-name="Path 31"
            d="M92.6,111.76,75.7,125.43,58.64,111.38a2.351,2.351,0,1,0-2.99,3.63c.26.22,18.4,15.17,18.68,15.37a2.335,2.335,0,0,0,2.83-.08l18.4-14.88a2.354,2.354,0,0,0-2.96-3.66Z"
            fill="#4d822b"
          />
          <path
            id="Path_32"
            data-name="Path 32"
            d="M63.52,98.63a2.346,2.346,0,0,0-3.08,3.54l5.61,4.87a2.346,2.346,0,1,0,3.08-3.54Z"
            fill="#4d822b"
          />
          <path
            id="Path_33"
            data-name="Path 33"
            d="M82.2,140.93a2.35,2.35,0,0,0,3.31.33l13.46-10.98a2.352,2.352,0,0,0-2.98-3.64L82.53,137.62A2.361,2.361,0,0,0,82.2,140.93Z"
            fill="#4d822b"
          />
          <path
            id="Path_34"
            data-name="Path 34"
            d="M101.68,99.1C95.32,85.62,80.75,69.24,77.5,65.27A2.348,2.348,0,0,0,73.35,67c-.06.36-.04-2.24-.04,44.52a2.471,2.471,0,0,0,4,1.84l13.92-10.99a2.35,2.35,0,0,0-2.91-3.69l-10.31,8.14V73.18c5.61,6.72,14.85,18.23,19.42,27.93,6.43,13.63,11.7,32.65.34,45.88-3.6,4.2-7.51,7.17-13.28,8.59a2.348,2.348,0,1,0,1.12,4.56c6.72-1.66,11.47-5.15,15.71-10.09C111.63,138.06,111.75,120.44,101.68,99.1Z"
            fill="#4d822b"
          />
        </g>
        <path
          id="Path_35"
          data-name="Path 35"
          d="M26.993-18.279h8.764V-3.756A22.851,22.851,0,0,1,28.846-.451,27.5,27.5,0,0,1,21.034.7a20.894,20.894,0,0,1-9.916-2.329A17.372,17.372,0,0,1,4.207-8.113a17.887,17.887,0,0,1-2.5-9.415,17.887,17.887,0,0,1,2.5-9.415,17.29,17.29,0,0,1,6.961-6.485,21.409,21.409,0,0,1,10.066-2.329A22.423,22.423,0,0,1,30.048-34.1a16.991,16.991,0,0,1,6.51,4.758l-6.31,5.709a11.123,11.123,0,0,0-8.514-3.906,9.867,9.867,0,0,0-7.262,2.729,9.8,9.8,0,0,0-2.754,7.287,10.585,10.585,0,0,0,1.252,5.183,8.978,8.978,0,0,0,3.506,3.556,10.279,10.279,0,0,0,5.158,1.277,12.668,12.668,0,0,0,5.359-1.152Zm23.688-5.609a8.856,8.856,0,0,1,3.781-2.779,14.344,14.344,0,0,1,5.334-.926v8.564a19.453,19.453,0,0,0-2.153-.15,6.636,6.636,0,0,0-4.783,1.653,6.7,6.7,0,0,0-1.728,5.058V0H41.616V-27.143h9.064ZM91.2-13.522q0,.1-.15,2.354H71.314a5.523,5.523,0,0,0,2.329,3.23,7.775,7.775,0,0,0,4.332,1.127,9.378,9.378,0,0,0,3.38-.551,9.974,9.974,0,0,0,2.88-1.8l5.008,5.208Q85.286.451,77.674.451a18.469,18.469,0,0,1-8.363-1.8A13.465,13.465,0,0,1,63.727-6.36a13.543,13.543,0,0,1-1.978-7.262,13.586,13.586,0,0,1,1.928-7.186,13.471,13.471,0,0,1,5.334-4.983,16.121,16.121,0,0,1,7.662-1.8,16.029,16.029,0,0,1,7.362,1.678,12.763,12.763,0,0,1,5.233,4.858A14.258,14.258,0,0,1,91.2-13.522ZM76.723-20.833a5.5,5.5,0,0,0-3.681,1.252,5.653,5.653,0,0,0-1.878,3.405H82.281A5.653,5.653,0,0,0,80.4-19.581,5.5,5.5,0,0,0,76.723-20.833Zm46.624,7.312q0,.1-.15,2.354H103.465a5.523,5.523,0,0,0,2.329,3.23,7.775,7.775,0,0,0,4.332,1.127,9.378,9.378,0,0,0,3.38-.551,9.974,9.974,0,0,0,2.88-1.8l5.008,5.208Q117.438.451,109.825.451a18.469,18.469,0,0,1-8.363-1.8A13.465,13.465,0,0,1,95.878-6.36,13.543,13.543,0,0,1,93.9-13.622a13.586,13.586,0,0,1,1.928-7.186,13.471,13.471,0,0,1,5.334-4.983,16.121,16.121,0,0,1,7.662-1.8,16.029,16.029,0,0,1,7.362,1.678,12.763,12.763,0,0,1,5.233,4.858A14.258,14.258,0,0,1,123.347-13.522Zm-14.473-7.312a5.5,5.5,0,0,0-3.681,1.252,5.653,5.653,0,0,0-1.878,3.405h11.118a5.653,5.653,0,0,0-1.878-3.405A5.5,5.5,0,0,0,108.874-20.833Zm36.558-6.761a11.155,11.155,0,0,1,8.138,3q3.08,3,3.08,9.064V0h-9.515V-13.972q0-5.559-4.457-5.559a5.09,5.09,0,0,0-3.931,1.6,6.878,6.878,0,0,0-1.477,4.808V0h-9.515V-27.143h9.064v2.955a10.786,10.786,0,0,1,3.806-2.529A12.894,12.894,0,0,1,145.432-27.594Zm17.177.451h9.515V0H162.61Zm4.758-3a6.024,6.024,0,0,1-4.207-1.452,4.669,4.669,0,0,1-1.6-3.606,4.669,4.669,0,0,1,1.6-3.606,6.024,6.024,0,0,1,4.207-1.452,6.228,6.228,0,0,1,4.207,1.377,4.445,4.445,0,0,1,1.6,3.531,4.857,4.857,0,0,1-1.6,3.731A5.961,5.961,0,0,1,167.367-30.148Zm21.284,4.006h6.46v7.111H188.9V0h-9.515V-19.03H175.43v-7.111h3.956v-.7a10.474,10.474,0,0,1,2.98-7.863q2.98-2.9,8.338-2.9a17.341,17.341,0,0,1,3.506.351,8.342,8.342,0,0,1,2.8,1.052L194.661-29.5a5.693,5.693,0,0,0-2.855-.8,3,3,0,0,0-2.329.9,3.8,3.8,0,0,0-.826,2.654Zm39.062-1L216,1.1q-2.053,5.008-5.008,7.036a12.436,12.436,0,0,1-7.212,2.028,14.552,14.552,0,0,1-4.332-.676,10.437,10.437,0,0,1-3.531-1.778l3.305-6.661a5.754,5.754,0,0,0,1.928,1.177,6.4,6.4,0,0,0,2.279.426,4.121,4.121,0,0,0,2.229-.551A4.229,4.229,0,0,0,207.131.351L195.512-27.143h9.766l6.661,16.576,6.711-16.576Z"
          transform="translate(127.866 127.381)"
          fill="#111827"
        />
      </g>
    </svg>
  );
};
export const LogoIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ height: "auto", width: "3rem" }}
      viewBox="0 0 66.92 96.805">
      <g
        id="Group_6"
        data-name="Group 6"
        transform="translate(-42.224 -64.405)">
        <path
          id="Path_30"
          data-name="Path 30"
          d="M56.71,126.54a2.349,2.349,0,0,0-3.03,3.59l19.64,16.59v9.69a28.516,28.516,0,0,1-19.72-9.42c-11.36-13.24-6.09-32.26.34-45.88,3.29-6.97,8.92-15.01,13.95-21.41a2.351,2.351,0,0,0-3.7-2.9c-5.18,6.59-11.03,14.94-14.5,22.3-10.07,21.34-9.95,38.96.34,50.95,6,6.99,15.25,11.06,25.37,11.16h.02a2.677,2.677,0,0,0,2.59-2.53V145.64a2.324,2.324,0,0,0-.83-1.79Z"
          fill="#4d822b"
        />
        <path
          id="Path_31"
          data-name="Path 31"
          d="M92.6,111.76,75.7,125.43,58.64,111.38a2.351,2.351,0,1,0-2.99,3.63c.26.22,18.4,15.17,18.68,15.37a2.335,2.335,0,0,0,2.83-.08l18.4-14.88a2.354,2.354,0,0,0-2.96-3.66Z"
          fill="#4d822b"
        />
        <path
          id="Path_32"
          data-name="Path 32"
          d="M63.52,98.63a2.346,2.346,0,0,0-3.08,3.54l5.61,4.87a2.346,2.346,0,1,0,3.08-3.54Z"
          fill="#4d822b"
        />
        <path
          id="Path_33"
          data-name="Path 33"
          d="M82.2,140.93a2.35,2.35,0,0,0,3.31.33l13.46-10.98a2.352,2.352,0,0,0-2.98-3.64L82.53,137.62A2.361,2.361,0,0,0,82.2,140.93Z"
          fill="#4d822b"
        />
        <path
          id="Path_34"
          data-name="Path 34"
          d="M101.68,99.1C95.32,85.62,80.75,69.24,77.5,65.27A2.348,2.348,0,0,0,73.35,67c-.06.36-.04-2.24-.04,44.52a2.471,2.471,0,0,0,4,1.84l13.92-10.99a2.35,2.35,0,0,0-2.91-3.69l-10.31,8.14V73.18c5.61,6.72,14.85,18.23,19.42,27.93,6.43,13.63,11.7,32.65.34,45.88-3.6,4.2-7.51,7.17-13.28,8.59a2.348,2.348,0,1,0,1.12,4.56c6.72-1.66,11.47-5.15,15.71-10.09C111.63,138.06,111.75,120.44,101.68,99.1Z"
          fill="#4d822b"
        />
      </g>
    </svg>
  );
};
export const FiltersIcons = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      role="img"
      className="iconify iconify--ph"
      style={{ height: "auto", width: "2rem" }}
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 256 256">
      <path
        d="M139.998 58.343V40a12 12 0 1 0-24 0v18.343a31.988 31.988 0 0 0 0 59.314V216a12 12 0 0 0 24 0v-98.343a31.988 31.988 0 0 0 0-59.314z"
        fill="#fff"></path>
      <path
        d="M231.998 168a32.045 32.045 0 0 0-20-29.657L212 40a12 12 0 1 0-24 0v98.343a31.988 31.988 0 0 0 0 59.314V216a12 12 0 0 0 24 0v-18.344a32.044 32.044 0 0 0 20-29.656z"
        fill="#fff"></path>
      <path
        d="M67.998 106.343V40a12 12 0 1 0-24 0v66.343a31.988 31.988 0 0 0 0 59.313V216a12 12 0 1 0 24 0v-50.343a31.988 31.988 0 0 0 0-59.314z"
        fill="#fff"></path>
    </svg>
  );
};
export const DotIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ height: "auto", width: "0.5rem" }}
      viewBox="0 0 5 5">
      <g
        id="Ellipse_2"
        data-name="Ellipse 2"
        fill="#6b7280"
        stroke="#707070"
        strokeWidth="1">
        <circle cx="2.5" cy="2.5" r="2.5" stroke="none" />
        <circle cx="2.5" cy="2.5" r="2" fill="none" />
      </g>
    </svg>
  );
};
export const HamburgerIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ height: "auto", width: "20px" }}
      viewBox="0 0 20 14">
      <g id="menu_1_" data-name="menu (1)" transform="translate(-2 -5)">
        <line
          id="Line_1"
          data-name="Line 1"
          x2="18"
          transform="translate(3 12)"
          fill="none"
          stroke="#111827"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <line
          id="Line_2"
          data-name="Line 2"
          x2="18"
          transform="translate(3 6)"
          fill="none"
          stroke="#111827"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <line
          id="Line_3"
          data-name="Line 3"
          x2="18"
          transform="translate(3 18)"
          fill="none"
          stroke="#111827"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
      </g>
    </svg>
  );
};
export const VisibleIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      style={style}
      fill="#6b7280">
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z" />
    </svg>
  );
};
export const VisibleOffIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      style={style}
      fill="#6b7280">
      <path
        d="M0 0h24v24H0V0zm0 0h24v24H0V0zm0 0h24v24H0V0zm0 0h24v24H0V0z"
        fill="none"
      />
      <path d="M12 6c3.79 0 7.17 2.13 8.82 5.5-.59 1.22-1.42 2.27-2.41 3.12l1.41 1.41c1.39-1.23 2.49-2.77 3.18-4.53C21.27 7.11 17 4 12 4c-1.27 0-2.49.2-3.64.57l1.65 1.65C10.66 6.09 11.32 6 12 6zm-1.07 1.14L13 9.21c.57.25 1.03.71 1.28 1.28l2.07 2.07c.08-.34.14-.7.14-1.07C16.5 9.01 14.48 7 12 7c-.37 0-.72.05-1.07.14zM2.01 3.87l2.68 2.68C3.06 7.83 1.77 9.53 1 11.5 2.73 15.89 7 19 12 19c1.52 0 2.98-.29 4.32-.82l3.42 3.42 1.41-1.41L3.42 2.45 2.01 3.87zm7.5 7.5l2.61 2.61c-.04.01-.08.02-.12.02-1.38 0-2.5-1.12-2.5-2.5 0-.05.01-.08.01-.13zm-3.4-3.4l1.75 1.75c-.23.55-.36 1.15-.36 1.78 0 2.48 2.02 4.5 4.5 4.5.63 0 1.23-.13 1.77-.36l.98.98c-.88.24-1.8.38-2.75.38-3.79 0-7.17-2.13-8.82-5.5.7-1.43 1.72-2.61 2.93-3.53z" />
    </svg>
  );
};
export const ProfileIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      viewBox="0 0 24 24"
      width="24px"
      fill="currentColor">
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z" />
    </svg>
  );
};
export const OrderIcon = () => {
  return (
    <svg style={style} viewBox="0 0 24 24">
      <path
        d="M4 20h2V10a1 1 0 0 1 1-1h12V7a1 1 0 0 0-1-1h-3.051c-.252-2.244-2.139-4-4.449-4S6.303 3.756 6.051 6H3a1 1 0 0 0-1 1v11a2 2 0 0 0 2 2zm6.5-16c1.207 0 2.218.86 2.45 2h-4.9c.232-1.14 1.243-2 2.45-2z"
        fill="currentColor"></path>
      <path
        d="M21 11H9a1 1 0 0 0-1 1v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8a1 1 0 0 0-1-1zm-6 7c-2.757 0-5-2.243-5-5h2c0 1.654 1.346 3 3 3s3-1.346 3-3h2c0 2.757-2.243 5-5 5z"
        fill="currentColor"></path>
    </svg>
  );
};
export const LogoutIcon = () => {
  return (
    <svg style={style} viewBox="0 0 24 24">
      <path
        d="M12 21c4.411 0 8-3.589 8-8c0-3.35-2.072-6.221-5-7.411v2.223A6 6 0 0 1 18 13c0 3.309-2.691 6-6 6s-6-2.691-6-6a5.999 5.999 0 0 1 3-5.188V5.589C6.072 6.779 4 9.65 4 13c0 4.411 3.589 8 8 8z"
        fill="#6b7280"></path>
      <path d="M11 2h2v10h-2z" fill="#6b7280"></path>
    </svg>
  );
};
export const ErrorIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      style={style}
      fill="#FFFFFF">
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
    </svg>
  );
};
export const NotFound = () => {
  return (
    <svg
      style={{ height: "auto", width: "280px" }}
      viewBox="0 0 1075 418"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M540.643 417.231C831.974 417.231 1068.14 401.596 1068.14 382.309C1068.14 363.023 831.974 347.388 540.643 347.388C249.313 347.388 13.1434 363.023 13.1434 382.309C13.1434 401.596 249.313 417.231 540.643 417.231Z"
        fill="#F2F2F2"
      />
      <path
        d="M520.426 0.00971985C434.482 0.00971985 372.775 55.1491 372.775 183.808C372.775 329.621 434.482 368.218 520.426 368.218C606.37 368.218 671.753 325.945 671.753 183.808C671.753 31.868 606.37 0.00971985 520.426 0.00971985ZM520.991 319.818C461.464 319.818 430.365 284.895 430.365 183.902C430.365 94.79 462.737 47.7972 522.264 47.7972C581.791 47.7972 614.163 78.6649 614.163 183.902C614.163 282.349 580.517 319.818 520.991 319.818Z"
        fill="#61973F"
      />
      <path
        d="M321.311 266.517H285.777V161.877C285.777 156.32 283.569 150.989 279.639 147.059C275.709 143.129 270.379 140.922 264.821 140.922H256.495C253.743 140.922 251.018 141.464 248.475 142.517C245.933 143.57 243.623 145.113 241.677 147.059C239.731 149.005 238.187 151.315 237.134 153.858C236.081 156.4 235.539 159.125 235.539 161.877V266.517H135.309C133.247 266.517 131.22 265.984 129.425 264.97C127.629 263.955 126.127 262.494 125.062 260.728C123.998 258.962 123.408 256.951 123.35 254.89C123.292 252.829 123.768 250.788 124.731 248.965L230.814 48.1844C232.136 45.6812 232.938 42.9359 233.17 40.1143C233.402 37.2927 233.061 34.4533 232.165 31.7675C231.27 29.0817 229.84 26.6051 227.961 24.4873C226.082 22.3695 223.793 20.6544 221.233 19.4455L214.971 16.4883C210.108 14.1921 204.549 13.853 199.444 15.5413C194.338 17.2296 190.077 20.8159 187.542 25.5583L58.1602 267.591C55.957 271.712 54.8043 276.314 54.8043 280.987V280.987C54.8043 284.719 55.5393 288.414 56.9673 291.861C58.3954 295.309 60.4885 298.441 63.1271 301.08C65.7658 303.719 68.8983 305.812 72.3459 307.24C75.7935 308.668 79.4885 309.403 83.2202 309.403H235.539V375.57C235.539 378.869 236.189 382.135 237.451 385.183C238.713 388.23 240.564 390.999 242.896 393.332C245.229 395.664 247.998 397.515 251.045 398.777C254.093 400.039 257.359 400.689 260.658 400.689H260.658C263.957 400.689 267.223 400.039 270.271 398.777C273.318 397.515 276.087 395.664 278.42 393.332C280.752 390.999 282.603 388.23 283.865 385.183C285.127 382.135 285.777 378.869 285.777 375.57V309.403H321.311C326.998 309.403 332.452 307.144 336.474 303.122C340.495 299.101 342.754 293.647 342.754 287.96V287.96C342.754 282.273 340.495 276.819 336.474 272.797C332.453 268.776 326.998 266.517 321.311 266.517V266.517Z"
        fill="#61973F"
      />
      <path
        d="M979.308 266.517H943.774V161.877C943.774 156.32 941.566 150.989 937.636 147.059C933.706 143.129 928.376 140.922 922.818 140.922H914.491C911.739 140.922 909.014 141.464 906.472 142.517C903.929 143.57 901.619 145.113 899.673 147.059C897.727 149.005 896.184 151.315 895.131 153.858C894.077 156.4 893.535 159.125 893.535 161.877V266.517H793.305C791.243 266.517 789.216 265.984 787.421 264.97C785.626 263.955 784.123 262.494 783.059 260.728C781.995 258.962 781.405 256.951 781.347 254.89C781.289 252.829 781.764 250.788 782.728 248.965L888.81 48.1844C890.133 45.6812 890.934 42.9359 891.167 40.1143C891.399 37.2928 891.057 34.4533 890.162 31.7675C889.266 29.0817 887.836 26.6051 885.957 24.4873C884.078 22.3695 881.79 20.6544 879.23 19.4455L872.967 16.4883C868.105 14.1921 862.546 13.853 857.44 15.5413C852.334 17.2296 848.073 20.8159 845.538 25.5583L716.157 267.591C713.953 271.712 712.801 276.314 712.801 280.987V280.987C712.801 288.523 715.795 295.751 721.124 301.08C726.453 306.409 733.68 309.403 741.217 309.403H893.535V375.57C893.535 382.232 896.182 388.621 900.893 393.332C905.603 398.043 911.992 400.689 918.654 400.689V400.689C925.316 400.689 931.706 398.043 936.416 393.332C941.127 388.621 943.773 382.232 943.773 375.57V309.403H979.308C984.995 309.403 990.449 307.144 994.47 303.122C998.492 299.101 1000.75 293.647 1000.75 287.96V287.96C1000.75 282.273 998.492 276.819 994.47 272.797C990.449 268.776 984.995 266.517 979.308 266.517Z"
        fill="#61973F"
      />
      <path
        d="M1006.86 252.55C1009.89 253.651 1013.14 254.034 1016.34 253.667C1019.54 253.301 1022.62 252.196 1025.32 250.439C1028.02 248.683 1030.28 246.322 1031.91 243.544C1033.55 240.766 1034.51 237.647 1034.74 234.431C1034.96 231.216 1034.43 227.992 1033.2 225.015C1031.96 222.038 1030.05 219.388 1027.62 217.275C1025.19 215.161 1022.3 213.642 1019.17 212.837C1016.05 212.032 1012.79 211.962 1009.64 212.634L1010.16 223.347L1005.09 214.166C1000.11 216.503 996.271 220.72 994.404 225.889C993.741 227.699 993.338 229.595 993.207 231.519C992.887 236.032 994.048 240.527 996.512 244.322C998.976 248.117 1002.61 251.006 1006.86 252.55V252.55Z"
        fill="#61973F"
      />
      <path
        d="M1031.94 376.793C1030.15 367.683 1037.9 359.606 1045.56 354.357C1053.22 349.107 1062.17 343.949 1064.78 335.04C1068.53 322.236 1057.35 310.51 1048.64 300.398C1042.19 292.894 1036.64 284.65 1032.12 275.841C1030.31 272.308 1028.64 268.615 1028.17 264.674C1027.48 258.999 1029.31 253.351 1031.14 247.938C1037.26 229.903 1043.8 212.02 1050.77 194.288"
        stroke="#3F3D56"
        stroke-miterlimit="10"
      />
      <path
        d="M1007.72 249.792C1010.75 250.893 1013.99 251.276 1017.2 250.909C1020.4 250.543 1023.47 249.438 1026.17 247.682C1028.88 245.925 1031.13 243.565 1032.77 240.787C1034.4 238.009 1035.37 234.889 1035.59 231.673C1035.82 228.458 1035.29 225.234 1034.06 222.257C1032.82 219.28 1030.91 216.63 1028.48 214.517C1026.04 212.403 1023.15 210.884 1020.03 210.079C1016.91 209.274 1013.64 209.204 1010.49 209.876L1011.01 220.589L1005.95 211.408C1000.97 213.745 997.128 217.962 995.262 223.131C994.599 224.941 994.196 226.837 994.064 228.761C993.745 233.274 994.905 237.769 997.369 241.564C999.833 245.359 1003.47 248.248 1007.72 249.792V249.792Z"
        stroke="#3F3D56"
        stroke-miterlimit="10"
      />
      <path
        d="M1029.4 190.588C1030.59 187.308 1032.58 184.38 1035.2 182.073C1037.82 179.767 1040.97 178.157 1044.38 177.391L1046.09 187.574L1049.27 176.879C1053.68 176.944 1057.96 178.41 1061.48 181.064C1065 183.718 1067.59 187.423 1068.87 191.645C1070.15 195.866 1070.06 200.386 1068.6 204.551C1067.15 208.715 1064.41 212.31 1060.78 214.815C1057.15 217.32 1052.81 218.607 1048.4 218.489C1043.99 218.371 1039.73 216.854 1036.24 214.158C1032.75 211.462 1030.21 207.726 1028.98 203.49C1027.74 199.253 1027.89 194.735 1029.4 190.588H1029.4Z"
        fill="#61973F"
      />
      <path
        d="M1030.54 186.911C1031.73 183.631 1033.72 180.703 1036.34 178.396C1038.96 176.09 1042.12 174.479 1045.52 173.713L1047.23 183.897L1050.41 173.201C1054.82 173.267 1059.1 174.732 1062.62 177.387C1066.15 180.041 1068.74 183.746 1070.02 187.968C1071.3 192.189 1071.2 196.709 1069.75 200.873C1068.29 205.038 1065.55 208.633 1061.92 211.138C1058.29 213.643 1053.96 214.93 1049.55 214.812C1045.14 214.694 1040.88 213.177 1037.38 210.481C1033.89 207.785 1031.35 204.049 1030.12 199.813C1028.89 195.576 1029.04 191.058 1030.54 186.911H1030.54Z"
        stroke="#3F3D56"
        stroke-miterlimit="10"
      />
      <path
        d="M1044.99 300.604C1049.8 302.347 1055.07 302.261 1059.82 300.363C1064.56 298.464 1068.44 294.886 1070.72 290.311C1072.99 285.735 1073.51 280.482 1072.16 275.553C1070.81 270.623 1067.7 266.362 1063.41 263.582L1060.97 271.801L1059.24 261.497C1059.22 261.489 1059.2 261.482 1059.18 261.477C1056.62 260.543 1053.89 260.125 1051.16 260.246C1048.42 260.367 1045.74 261.025 1043.27 262.182C1040.79 263.339 1038.56 264.973 1036.72 266.991C1034.87 269.008 1033.44 271.369 1032.51 273.94C1031.58 276.51 1031.16 279.238 1031.29 281.97C1031.41 284.701 1032.07 287.381 1033.23 289.857C1034.39 292.334 1036.02 294.557 1038.04 296.401C1040.06 298.245 1042.42 299.674 1044.99 300.604H1044.99Z"
        fill="#61973F"
      />
      <path
        d="M1045.98 296.88C1050.79 298.622 1056.06 298.536 1060.81 296.638C1065.55 294.74 1069.43 291.162 1071.71 286.586C1073.99 282.011 1074.5 276.758 1073.15 271.828C1071.8 266.899 1068.69 262.638 1064.4 259.857L1061.96 268.076L1060.23 257.772C1060.21 257.764 1060.19 257.758 1060.17 257.752C1057.61 256.818 1054.88 256.4 1052.15 256.521C1049.41 256.642 1046.73 257.3 1044.26 258.457C1041.78 259.615 1039.55 261.249 1037.71 263.266C1035.86 265.284 1034.43 267.645 1033.5 270.215C1032.57 272.785 1032.15 275.514 1032.28 278.245C1032.4 280.976 1033.06 283.656 1034.22 286.133C1035.38 288.609 1037.01 290.833 1039.03 292.677C1041.05 294.521 1043.41 295.949 1045.98 296.88H1045.98Z"
        stroke="#3F3D56"
        stroke-miterlimit="10"
      />
      <path
        d="M1023.32 335.167C1024.15 339.867 1026.57 344.14 1030.17 347.27C1033.77 350.4 1038.34 352.195 1043.11 352.356C1047.88 352.517 1052.56 351.032 1056.37 348.152C1060.17 345.272 1062.87 341.171 1064.01 336.537C1065.15 331.903 1064.66 327.018 1062.63 322.701C1060.59 318.384 1057.14 314.897 1052.84 312.826C1048.54 310.755 1043.66 310.225 1039.02 311.326C1034.37 312.426 1030.25 315.09 1027.33 318.87L1036.61 332.826L1023.94 325.418C1022.95 328.572 1022.74 331.915 1023.32 335.167V335.167Z"
        fill="#61973F"
      />
      <path
        d="M1024.18 332.409C1025.01 337.109 1027.42 341.382 1031.03 344.512C1034.63 347.642 1039.2 349.437 1043.97 349.598C1048.74 349.759 1053.42 348.274 1057.22 345.394C1061.03 342.514 1063.73 338.413 1064.87 333.779C1066.01 329.145 1065.52 324.26 1063.49 319.943C1061.45 315.626 1058 312.139 1053.7 310.068C1049.4 307.997 1044.52 307.467 1039.87 308.568C1035.23 309.668 1031.1 312.332 1028.19 316.112L1037.46 330.068L1024.79 322.661C1023.81 325.814 1023.6 329.157 1024.18 332.409V332.409Z"
        stroke="#3F3D56"
        stroke-miterlimit="10"
      />
      <path
        d="M9.00746 303.249C10.9978 303.972 13.1289 304.224 15.2329 303.983C17.337 303.743 19.3563 303.017 21.1319 301.862C22.9075 300.708 24.3908 299.157 25.4648 297.332C26.5388 295.507 27.1742 293.457 27.3208 291.345C27.4675 289.232 27.1215 287.114 26.3101 285.158C25.4987 283.202 24.244 281.461 22.645 280.073C21.0459 278.684 19.1463 277.686 17.0957 277.157C15.0451 276.628 12.8997 276.582 10.8285 277.024L11.1707 284.062L7.84085 278.03C4.57278 279.566 2.04805 282.336 0.821494 285.732C0.385892 286.922 0.121078 288.167 0.034953 289.431C-0.17523 292.397 0.586979 295.35 2.20607 297.843C3.82517 300.337 6.2129 302.234 9.00746 303.249V303.249Z"
        fill="#61973F"
      />
      <path
        d="M25.4837 384.879C24.3083 378.893 29.4017 373.587 34.4329 370.138C39.464 366.689 45.3427 363.3 47.0593 357.446C49.5264 349.034 42.1776 341.33 36.4579 334.686C32.2144 329.756 28.5702 324.34 25.6016 318.551C24.311 316.278 23.4319 313.794 23.0049 311.215C22.5539 307.486 23.7519 303.775 24.9588 300.219C28.9794 288.37 33.2782 276.62 37.8551 264.969"
        stroke="#3F3D56"
        stroke-miterlimit="10"
      />
      <path
        d="M9.57064 301.437C11.5609 302.16 13.6921 302.412 15.7961 302.171C17.9001 301.931 19.9195 301.205 21.6951 300.05C23.4707 298.896 24.9539 297.345 26.0279 295.52C27.1019 293.695 27.7373 291.645 27.884 289.533C28.0307 287.42 27.6847 285.302 26.8733 283.346C26.0618 281.39 24.8072 279.649 23.2081 278.261C21.6091 276.872 19.7094 275.874 17.6589 275.345C15.6083 274.816 13.4628 274.77 11.3916 275.212L11.7339 282.25L8.40403 276.218C5.13595 277.754 2.61122 280.524 1.38467 283.92C0.949069 285.11 0.684259 286.355 0.598129 287.619C0.387932 290.585 1.15014 293.538 2.76923 296.031C4.38833 298.525 6.77607 300.422 9.57064 301.437V301.437Z"
        stroke="#3F3D56"
        stroke-miterlimit="10"
      />
      <path
        d="M23.8124 262.539C24.5935 260.384 25.9044 258.46 27.6244 256.945C29.3444 255.429 31.4181 254.371 33.6545 253.868L34.7803 260.559L36.8677 253.532C39.7659 253.575 42.5754 254.537 44.8907 256.281C47.206 258.025 48.9071 260.46 49.7486 263.233C50.5901 266.007 50.5283 268.976 49.5723 271.712C48.6162 274.449 46.8152 276.81 44.4295 278.456C42.0437 280.102 39.1966 280.948 36.2991 280.87C33.4016 280.793 30.6038 279.796 28.3095 278.025C26.0152 276.254 24.3432 273.799 23.5349 271.016C22.7265 268.232 22.8237 265.264 23.8124 262.539V262.539Z"
        fill="#61973F"
      />
      <path
        d="M24.5632 260.123C25.3443 257.968 26.6552 256.044 28.3752 254.529C30.0952 253.013 32.169 251.955 34.4053 251.452L35.5312 258.143L37.6186 251.116C40.5168 251.158 43.3263 252.121 45.6415 253.865C47.9568 255.609 49.658 258.044 50.4995 260.817C51.3409 263.591 51.2792 266.56 50.3231 269.296C49.367 272.033 47.5661 274.394 45.1803 276.04C42.7946 277.686 39.9474 278.532 37.0499 278.454C34.1525 278.377 31.3546 277.38 29.0603 275.609C26.7661 273.838 25.094 271.383 24.2857 268.599C23.4774 265.816 23.5746 262.848 24.5632 260.123V260.123Z"
        stroke="#3F3D56"
        stroke-miterlimit="10"
      />
      <path
        d="M34.0576 334.822C37.214 335.967 40.6813 335.91 43.7987 334.663C46.9162 333.415 49.4656 331.065 50.9612 328.059C52.4568 325.052 52.7939 321.601 51.9083 318.362C51.0227 315.124 48.9763 312.324 46.1592 310.497L44.5553 315.897L43.418 309.127C43.4067 309.122 43.3951 309.118 43.3832 309.114C41.6948 308.5 39.9021 308.225 38.1073 308.304C36.3126 308.384 34.551 308.816 32.9234 309.576C31.2957 310.336 29.8338 311.41 28.6213 312.736C27.4088 314.061 26.4693 315.613 25.8567 317.301C25.2441 318.99 24.9703 320.783 25.0509 322.578C25.1315 324.373 25.565 326.134 26.3266 327.761C27.0882 329.388 28.163 330.849 29.4895 332.061C30.816 333.272 32.3683 334.21 34.0576 334.822V334.822Z"
        fill="#61973F"
      />
      <path
        d="M34.7081 332.374C37.8645 333.519 41.3319 333.463 44.4493 332.216C47.5667 330.968 50.1162 328.618 51.6118 325.611C53.1074 322.605 53.4445 319.154 52.5589 315.915C51.6733 312.676 49.6269 309.877 46.8098 308.05L45.2059 313.45L44.0685 306.68C44.0573 306.675 44.0457 306.67 44.0337 306.667C42.3458 306.055 40.5537 305.781 38.7599 305.861C36.9661 305.941 35.2057 306.374 33.5791 307.135C30.2941 308.671 27.7539 311.449 26.5172 314.858C25.2806 318.267 25.4488 322.028 26.9849 325.313C28.521 328.597 31.2991 331.138 34.7081 332.374V332.374Z"
        stroke="#3F3D56"
        stroke-miterlimit="10"
      />
      <path
        d="M19.822 357.53C20.3647 360.618 21.9528 363.426 24.3198 365.482C26.6868 367.538 29.6889 368.718 32.8226 368.823C35.9562 368.929 39.0309 367.954 41.5309 366.061C44.0309 364.169 45.8042 361.475 46.5535 358.43C47.3027 355.385 46.9823 352.176 45.6459 349.339C44.3096 346.503 42.0386 344.212 39.2139 342.852C36.3891 341.491 33.1823 341.143 30.1314 341.866C27.0804 342.589 24.3708 344.339 22.457 346.822L28.5493 355.992L20.2249 351.125C19.5795 353.197 19.4413 355.393 19.822 357.53V357.53Z"
        fill="#61973F"
      />
      <path
        d="M20.3851 355.718C20.9278 358.806 22.5159 361.614 24.8829 363.67C27.25 365.726 30.252 366.906 33.3857 367.011C36.5194 367.117 39.594 366.142 42.094 364.249C44.594 362.357 46.3673 359.663 47.1166 356.618C47.8658 353.573 47.5454 350.364 46.2091 347.527C44.8727 344.691 42.6017 342.4 39.777 341.039C36.9522 339.679 33.7454 339.331 30.6945 340.054C27.6435 340.777 24.9339 342.527 23.0201 345.01L29.1124 354.18L20.788 349.313C20.1426 351.385 20.0044 353.581 20.3851 355.718V355.718Z"
        stroke="#3F3D56"
        stroke-miterlimit="10"
      />
    </svg>
  );
};
export const ThreeDotsIcon = () => {
  return (
    <svg
      id="more_vert_black_24dp"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      viewBox="0 0 24 24">
      <path id="Path_26" data-name="Path 26" d="M0,0H24V24H0Z" fill="none" />
      <path
        id="Path_27"
        data-name="Path 27"
        d="M12,8a2,2,0,1,0-2-2A2.006,2.006,0,0,0,12,8Zm0,2a2,2,0,1,0,2,2A2.006,2.006,0,0,0,12,10Zm0,6a2,2,0,1,0,2,2A2.006,2.006,0,0,0,12,16Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const EditIcon = () => {
  return (
    <svg
      id="edit_black_24dp"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      viewBox="0 0 24 24">
      <path id="Path_28" data-name="Path 28" d="M0,0H24V24H0Z" fill="none" />
      <path
        id="Path_29"
        data-name="Path 29"
        d="M14.06,9.02l.92.92L5.92,19H5v-.92l9.06-9.06M17.66,3a1,1,0,0,0-.7.29L15.13,5.12l3.75,3.75,1.83-1.83a1,1,0,0,0,0-1.41L18.37,3.29A.982.982,0,0,0,17.66,3Zm-3.6,3.19L3,17.25V21H6.75L17.81,9.94,14.06,6.19Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const DeleteIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      style={style}
      fill="currentColor">
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" />
    </svg>
  );
};

export const AddressIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      style={style}
      fill="currentColor">
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M21 5c-1.11-.35-2.33-.5-3.5-.5-1.95 0-4.05.4-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5S2.45 4.9 1 6v14.65c0 .25.25.5.5.5.1 0 .15-.05.25-.05C3.1 20.45 5.05 20 6.5 20c1.95 0 4.05.4 5.5 1.5 1.35-.85 3.8-1.5 5.5-1.5 1.65 0 3.35.3 4.75 1.05.1.05.15.05.25.05.25 0 .5-.25.5-.5V6c-.6-.45-1.25-.75-2-1zm0 13.5c-1.1-.35-2.3-.5-3.5-.5-1.7 0-4.15.65-5.5 1.5V8c1.35-.85 3.8-1.5 5.5-1.5 1.2 0 2.4.15 3.5.5v11.5z" />
    </svg>
  );
};
